import React from "react"

import { SelectionContainer } from "./course-filter.style"
import CourseFilterDropdown from "./course-filter-dropdown.component"
import { filterData } from "./options-data"
import dataLayerHelper from "../../helpers/datalayer.helper"



const CourseSort = ({ setCourseFilter, courseFilter }) => {
    const { sortByValue } = courseFilter
    const { sortByLabelledOptions } = filterData

    const onSortByChange = (option) => {
        setCourseFilter({
            ...courseFilter,
            sortByValue: option.value,
            showResult: true,
        })

        dataLayerHelper({
            event: "coursePageFilter",
            action: "Sort By",
            label: option.label,
            primaryTag: courseFilter.primaryTag,
            secondaryTag: courseFilter.secondaryTag,
            formatTag: courseFilter.formatTag,
            // Has to be option.value! courseFilter is not updated at the time this is executed.
            sortBy: option.value,
        })
    }

    return (
        <SelectionContainer>
            <CourseFilterDropdown
                options={sortByLabelledOptions}
                handleChange={(option) => {
                    onSortByChange(option)
                }}
                activeValue={sortByValue}
            />
        </SelectionContainer>
    )
}

export default CourseSort;